module.exports = __webpack_public_path__ + "assets/img/rozwiazania-dla-firm.d06aaaf9.jpg";